import { defineAction, object, string, number, array, enumerated } from '~/prix'
import viewListAction from './viewList.action.json' with { type: 'json' }
import { orderBy } from '~/prix/utils/sql'

const viewListDefinition = defineAction({
  ...viewListAction,

  input: object({
    orderBy: enumerated({
      relevance: 'relevance',
      title: 'title',
    }).isOptional(),
    search: string().isOptional(),
    category: string().isOptional(),
    path: string().isOptional(),
    startIndex: number().isOptional(),
    endIndex: number().isOptional(),
  }),
  output: object({
    items: array(object({})).isOptional(),
    pagesLeft: number().isOptional(),
    variablesCount: number().isOptional(),
    total: number().isOptional(),
  }),

  cache: input => {
    if (input.search) {
      return {}
    }

    return {
      back: {
        // 2 days
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 2,
        // 5 minutes
        expirationMsForUpdate: 1000 * 60 * 5,
      },
      front: {
        // 5 days
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 5,
        // 5 minutes
        expirationMsForUpdate: 1000 * 60 * 5,
      },
    }
  },
})

export default viewListDefinition
